import React, { useEffect, useReducer } from 'react';
import { useFieldArray, useForm } from 'react-hook-form';
// import { useHistory, useParams } from 'react-router';
import { userService } from './userService';
import { FormObjectList, ImageUpload } from '../common';
import { useNavigate , useParams  } from 'react-router-dom';
import { useAuth } from '../auth/Authcontext';
import { toast } from 'react-toastify';
import Swal from 'sweetalert2'
import { breedOptions } from '../horse/HorseCreate';
import { isHttpUrl } from '../utilities/apiUtilities';


const roleOptions = [
    'Owner',
    'Administrator',
    'Horse Owner',
    'User'
]

const initialState = {
    isLoading: true,
    isSubmitting: false,
    isEditting: false,
    user: undefined,
    uploadImage: undefined
}

const ACTIONS = {
    USER_GET_CALL: 'USER_GET_CALL',
    USER_GET_SUCCESS: 'USER_GET_SUCCESS',
    USER_GET_ERROR: 'USER_GET_ERROR',
    TOGGLE_EDIT: 'TOGGLE_EDIT',
    UPDATE_UPLOAD_IMAGE: 'UPDATE_UPLOAD_IMAGE',
    USER_UPDATE_CALL: 'USER_UPDATE_CALL',
    USER_UPDATE_SUCCESS: 'USER_UPDATE_SUCCESS',
    USER_UPDATE_ERROR: 'USER_UPDATE_ERROR'
}

function reducer(state, action) {
    switch (action.type) {
        case ACTIONS.USER_GET_CALL:
            return {
                ...state, 
                isLoading: true
            }
        case ACTIONS.USER_GET_SUCCESS:
            return {
                ...state,
                isLoading: false,
                isSubmitting: false,
                user: {
                    ...action.data
                }
            }
        case ACTIONS.TOGGLE_EDIT:
            let isEditting = !state.isEditting
            return {
                ...state,
                isEditting: isEditting,
                uploadImage: isEditting ? state.uploadImage : undefined
            }
        case ACTIONS.UPDATE_UPLOAD_IMAGE:
            return {
                ...state,
                uploadImage: action.data
            }
        case ACTIONS.USER_UPDATE_CALL:
            return {
                ...state,
                isSubmitting: true,
                isLoading: false
            }
        case ACTIONS.USER_UPDATE_ERROR:
            return {
                ...state,
                isLoading: false,
                isSubmitting: false,
                isEditting: true
            }
        case ACTIONS.USER_UPDATE_SUCCESS:
            return {
                ...state,
                isLoading: false,
                isSubmitting: false,
                isEditting: false,
                user: {
                    ...action.data
                }
            }
        default:
            throw new Error(`No action of type ${action.type} found in reducer.`)
    }
}

function UserEdit() {
    const {contextValue} = useAuth();

    const { userId } = useParams();
    const [state, dispatch] = useReducer(reducer, initialState);
    const { register, handleSubmit, reset, control, formState: { errors } } = useForm();
    const { fields, append, remove } = useFieldArray({ control, name: 'user.roles' });
    // const history = useHistory();
    const navigate = useNavigate();
    useEffect(() => {
        dispatch({ type: ACTIONS.USER_GET_CALL });
        userService.getUser(userId)
        .then(response => dispatch({ type: ACTIONS.USER_GET_SUCCESS, data: response.data }))
        .catch(error => console.error(error));
    }, [userId]);

    useEffect(() => {
        if (state.user || !state.isEditting) {
            reset({user: state.user});
        }
    }, [state.user, state.isEditting, reset]);

    function handleEditClick(event) {
        event.preventDefault();
        dispatch({ type: ACTIONS.TOGGLE_EDIT });
    }

    function handleDeleteClick(event) {
        event.preventDefault();
        // if (window.confirm(`This will permanently delete the record for ${state.user.profile.stableName}, and any asscoiated records such as scores and selections. There is no way to undo this action. The user will be forced to recreate their account. Press 'Ok' if you are sure you want to delete ${state.user.profile.stableName}.`)) {
        //     userService.deleteUser(userId);
        //     window.alert(`${state.user.profile.stableName} has been deleted.`);
        //     //history.push('/user');
        //     navigate('/user');
        // }


        const message = `This will permanently delete the record for ${state.user.profile.stableName}, and any asscoiated records such as scores and selections. There is no way to undo this action.`

        Swal.fire({
            title: 'Are you sure?',
            text: message,
            // icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#3085d6',
            confirmButtonText: 'Yes, delete it!',
            heightAuto: false
          }).then((result) => {
            if (result.isConfirmed) {

                contextValue.showLoader();
                contextValue.updateLoaderText("Deleting horse...");

                userService.deleteUser(userId).then(response => {
                    toast.success(`${state.user.profile.stableName} has been deleted.`);
                    navigate('/user');
                })
                .catch(error => {
                    console.error(error);
                    toast.error("Error deleting user");
                })
                .finally(() => contextValue.hideLoader());

              // delete logic here
            }
          });



    }

    function handleSaveClick({user}) {
        //HACK: Unexplodes strings that get exploded during the usefieldarray append process.
        let roles = [];
        user.roles.forEach(item => {
            if (typeof item === 'object') {
                roles.push(Object.values(item).join(""));
            } else {
                roles.push(item);
            }
        });
        contextValue.showLoader();
        contextValue.updateLoaderText("Updating user...");

        dispatch({ type: ACTIONS.USER_UPDATE_CALL });
        userService.updateUserProfile(userId, {
            ...user,
            roles: roles, 
            profile: {
                ...user.profile,
                profilePicture: state.uploadImage
            }
        })


        .then(response => {
            dispatch({ type: ACTIONS.USER_UPDATE_SUCCESS, data: response.data })
            toast.success("User updated successfully");
        })
        .catch(error => {
            toast.error("Error updating user");
            dispatch({ type: ACTIONS.USER_UPDATE_ERROR, data: error.response.data })
        })
        .finally(() => contextValue.hideLoader());


        // .then(response => dispatch({ type: ACTIONS.USER_UPDATE_SUCCESS, data: response.data }));
    }

    function handleImageUpload(image) {
        dispatch({ type: ACTIONS.UPDATE_UPLOAD_IMAGE, data: image});
    }

    function handleNewRoleClick(event) {
        event.preventDefault();
        append('User', {});
    }

    function renderProfilePicture() {

        console.log(state)
        let src;
        if (state.uploadImage) {
            src = URL.createObjectURL(state.uploadImage);
        } else if (state.user.profile.profilePicturePath) {
            if(isHttpUrl(state.user.profile.profilePicturePath)) {
                src = state.user.profile.profilePicturePath
            }else{
                src = `${process.env.REACT_APP_AWS_S3}${state.user.profile.profilePicturePath}`
            }
        } else {
            src = '/images/horse_image_default.jpg'
        }

        return (
            <img className='m-auto mb-3 w-100 rounded-3' src={src} alt ='User Profile Picture'/>
        );
    }

    function renderRoleOptions() {
        return roleOptions.map((item) => (
            <option key={`role${item}`} value={item}>{item}</option>
        ))
    }

    function renderRoles(index) {
        return (
            <div className="card mb-3">
                <div className="card-body row">
                    <div className="col">
                        <label htmlFor={`roles${index}`} className="form-label">Role:</label>
                        <select type="text" className="form-select" id={`roles${index}`} {...register(`user.roles[${index}]`)} disabled={!state.isEditting}>
                            {renderRoleOptions()}
                        </select>
                    </div>
                    {state.isEditting &&
                        <div className="col-auto">
                            <button className="btn btn-danger text-white" onClick={() => remove(index)}>
                                <i className="bi bi-x-lg me-2"></i>
                                Remove
                            </button>
                        </div>
                    }
                </div>
            </div>
        );
    }

    function renderBreedOptions() {
        return breedOptions.map((item) => (
            <option key={`breed${item}`} value={item}>{item}</option>
        ));
    }



    return (
        <div className='container h-100 overflow-auto'>
        {!state.isLoading &&
            <form>
                <div className='row mb-3'>
                    <h2 className='col'>{state.user.profile.stableName}</h2>
                    {!state.isEditting &&
                        <div className='col-auto'>
                            <button className='btn btn-primary me-2' onClick={handleEditClick}>Edit</button>
                            <button className='btn btn-danger text-white' onClick={handleDeleteClick}>Delete</button>
                        </div>
                    }
                    {state.isEditting &&
                        <div className='col-auto'>
                            <button type='submit' className='btn btn-success text-white me-2' onClick={handleSubmit(handleSaveClick)}>Save</button>
                            <button className='btn btn-primary' onClick={handleEditClick}>Cancel</button>
                        </div>
                    }
                </div>
                <div className="row">
                    <div className='col-sm col-lg-auto mb-3'>
                        <div className='picture-container m-auto'>
                            {renderProfilePicture()}
                            {state.isEditting &&
                                <button type='button' className='btn btn-primary w-100' data-bs-toggle='modal' data-bs-target='#photoUpload'>
                                    Upload Profile Picture
                                </button>
                            }
                            <ImageUpload id='photoUpload' aspectRatio={1} onUpload={handleImageUpload}/>
                        </div>
                    </div>
                    <div className='col-lg'>
                        <div className='row mb-3'>
                            <div className='col'>
                                <label htmlFor='userStableName' className='form-label'>Stable Name:</label>
                                <input type='text' className='form-control' id='userStableName' autoComplete='off' {...register('user.profile.stableName', {required: true})} disabled={!state.isEditting}/>
                                {errors.user?.profile?.stableName?.type === 'required' && <div className='text-danger form-text'>Name is required</div>}
                            </div>
                        </div>
                        <div className='row mb-3'>
                            <div className="col">
                                <label htmlFor="userFirstName" className="form-label">First Name:</label>
                                <input type="text" className="form-control" id="userFirstName" autoComplete='off' {...register('user.profile.firstName')} disabled={!state.isEditting}/>
                            </div>
                            <div className="col">
                                <label htmlFor="userLastName" className="form-label">Last Name:</label>
                                <input type="text" className="form-control" id="userLastName" autoComplete='off' {...register('user.profile.lastName')} disabled={!state.isEditting}/>
                            </div>
                        </div>
                        <div className='row mb-3'>
                            <div className="col">
                                <label htmlFor="userFavoriteBreed" className="form-label">Favorite Breed:</label>
                                {/* <select className='form-select'  id='userFavoriteBreed' autoComplete='off' {...register('user.profile.favoriteBreed')} disabled={!state.isEditting}> 
                                    {renderBreedOptions()}
                                </select> */}


                               <input type="text" className="form-control" id="userFavoriteBreed" autoComplete='off' {...register('user.profile.favoriteBreed')} disabled={!state.isEditting}/>
                            </div>
                            <div className="col">
                                <label htmlFor="userFavoriteDiscipline" className="form-label">Favorite Discipline:</label>
                                <input type="text" className="form-control" id="userFavoriteDiscipline" autoComplete='off' {...register('user.profile.favoriteDiscipline')} disabled={!state.isEditting}/>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row mb-3">
                    <h3 className='col'>Roles</h3>
                    {state.isEditting &&
                        <div className='col-auto'>
                            <button className='btn btn-primary me-2' onClick={handleNewRoleClick}>
                                <i className='bi bi-plus-lg me-2'></i>
                                Add
                            </button>
                        </div>
                    }
                </div>
                <FormObjectList
                    objectCount={fields.length}
                    objects={fields}
                    keyExtractor={(index) => fields[index].id}
                    render={renderRoles}
                />
            </form>
        }
    </div>
    );
}

export default UserEdit;